import clsx from 'clsx';

export interface IconSmallCheckProps {
  className?: string;
}

const IconSmallCheck = ({ className }: IconSmallCheckProps) => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      'transition-all duration-300 motion-reduce:transition-none',
      className,
    )}
  >
    <path d="M4.97897 9.646C4.86764 9.646 4.75997 9.625 4.65597 9.583C4.55197 9.54167 4.4513 9.47234 4.35397 9.375L0.832969 5.854C0.666303 5.68734 0.586636 5.47567 0.593969 5.219C0.600636 4.96167 0.687303 4.74967 0.853969 4.583C1.02064 4.41634 1.22897 4.333 1.47897 4.333C1.72897 4.333 1.9373 4.41634 2.10397 4.583L5.02097 7.5L11.917 0.604004C12.0836 0.437337 12.2883 0.354004 12.531 0.354004C12.7743 0.354004 12.9793 0.437337 13.146 0.604004C13.3126 0.770671 13.396 0.97567 13.396 1.219C13.396 1.46167 13.3126 1.66634 13.146 1.833L5.60397 9.375C5.50664 9.47234 5.40597 9.54167 5.30197 9.583C5.19797 9.625 5.0903 9.646 4.97897 9.646Z" />
  </svg>
);

export default IconSmallCheck;
